module.exports = __webpack_public_path__ + "img/lacava_logo.38872c05.png";